// Generated by scripts/referentiel/extract.mjs — do not edit by hand.
//
// Référentiel de français et langues anciennes
// https://ifpc-fwb.be/v5/documents/tc/refFRALA.pdf
// SHA-256 3f1b31814d382e26b2dea9deefc1944ce28745ad4fa0664ef71b8d40565798f3
// P3: pages 70-87, extractor v1

import type { Attendu } from './types.ts';

export const ATTENDUS: readonly Attendu[] = [
  {
    id: "FRALA-P3-ba4d05ee",
    champ: "",
    section: "Orienter sa prise de parole, son écoute, sa lecture, son écrit",
    kind: "Savoir",
    parent: "Composantes de la situation de communication.",
    modality: "écouter, parler, lire, écrire",
    text: "Citer les paramètres de la communication : énonciateur (qui ?), destinataire (à qui ?), intention dominante (pour quoi ?), message (quoi ?), contexte (où ? quand ?).",
  },
  {
    id: "FRALA-P3-4ded3b9b",
    champ: "",
    section: "Orienter sa prise de parole, son écoute, sa lecture, son écrit",
    kind: "Savoir",
    parent: "Composantes de la situation de communication.",
    modality: "écouter, parler, lire, écrire",
    text: "Repérer la diversité des interlocuteurs : - connu/inconnu ; - familier/non familier ; - un/plusieurs ; - du même âge/plus jeune/plus âgé.",
  },
  {
    id: "FRALA-P3-6c665054",
    champ: "",
    section: "Orienter sa prise de parole, son écoute, sa lecture, son écrit",
    kind: "Savoir",
    parent: "Composantes de la situation de communication.",
    modality: "lire",
    text: "Désigner : livre, première et quatrième de couverture, titre, sous-titre, paragraphe, nom de l’auteur, nom de l’illustrateur.",
  },
  {
    id: "FRALA-P3-1bd14b10",
    champ: "",
    section: "Orienter sa prise de parole, son écoute, sa lecture, son écrit",
    kind: "Savoir",
    parent: "Termes du support de lecture (paratexte*).",
    modality: "écouter, parler, lire, écrire",
    text: "Connaitre les intentions : - informer ; - donner du plaisir/susciter des émotions ; - enjoindre ; - persuader/convaincre.",
  },
  {
    id: "FRALA-P3-d10920b6",
    champ: "",
    section: "Orienter sa prise de parole, son écoute, sa lecture, son écrit",
    kind: "Savoir",
    parent: "Intentions de communication.",
    modality: "écouter, lire",
    text: "Identifier le support d’écoute et de lecture utilisé.",
  },
  {
    id: "FRALA-P3-b7634d0f",
    champ: "",
    section: "Construire un message significatif",
    kind: "Savoir",
    parent: "Support de communication (papier ou numérique).",
    modality: "lire, écrire",
    text: "Connaitre l’ensemble des correspondances graphophonétiques simples ou complexes et rares.",
  },
  {
    id: "FRALA-P3-1f228761",
    champ: "",
    section: "Construire un message significatif",
    kind: "Savoir",
    parent: "Correspondances graphophonétiques.",
    modality: "lire, écrire",
    text: "Désigner une consonne, une voyelle, accent aigu, accent grave, accent circonflexe, cédille.",
  },
  {
    id: "FRALA-P3-4d783c11",
    champ: "",
    section: "Construire un message significatif",
    kind: "Savoir",
    parent: "Termes du langage technique de la lecture-écriture.",
    modality: "lire, écrire",
    text: "Nommer les signes de ponctuation rencontrés dans les phrases et les textes : le point, le point d’interrogation, le point d’exclamation, les guillemets, le tiret, les points de suspension.",
  },
  {
    id: "FRALA-P3-e1bd05c7",
    champ: "",
    section: "Construire un message significatif",
    kind: "Savoir",
    parent: "Caractéristiques graphiques de la phrase.",
    modality: "lire, écrire",
    text: "Désigner les signes de ponctuation rencontrés dans les phrases et les textes : la virgule (dans les énumérations).",
  },
  {
    id: "FRALA-P3-4225799e",
    champ: "",
    section: "Construire un message significatif",
    kind: "Savoir",
    parent: "Caractéristiques graphiques de la phrase.",
    modality: "écouter, parler, lire, écrire",
    text: "Connaitre et comprendre les mots du lexique spécifique à une thématique ou à un champ disciplinaire.",
  },
  {
    id: "FRALA-P3-9c5c72c3",
    champ: "",
    section: "Construire un message significatif",
    kind: "Savoir",
    parent: "Lexique spécifique.",
    modality: "écouter, parler, lire, écrire",
    text: "Connaitre et comprendre les mots usuels traités dans les messages oraux et dans les supports de lecture de la classe.",
  },
  {
    id: "FRALA-P3-440a3532",
    champ: "",
    section: "Construire un message significatif",
    kind: "Savoir",
    parent: "Lexique courant.",
    modality: "écouter, parler, lire, écrire",
    text: "Connaitre les notions de famille de mots, de racine.",
  },
  {
    id: "FRALA-P3-a20fb9ab",
    champ: "",
    section: "Construire un message significatif",
    kind: "Savoir",
    parent: "Règles d’orthographe lexicale : construction des mots (morphologie).",
    modality: "écouter, parler, lire, écrire",
    text: "Connaitre les constantes orthographiques liées à l’emploi : - de certains graphèmes (en lien avec une famille morphologique*) ; - de certains phonèmes (le son /ɛj/ s’écrit -eil à la fin d’un mot masculin et -eille d’un mot féminin…).",
  },
  {
    id: "FRALA-P3-c950cfe4",
    champ: "",
    section: "Construire un message significatif",
    kind: "Savoir",
    parent: "Règles d’orthographe lexicale : construction des mots (morphologie).",
    modality: "écouter, parler, lire, écrire",
    text: "Connaitre des mots contenant des graphèmes rares (simples ou complexes).",
  },
  {
    id: "FRALA-P3-0f4ce43c",
    champ: "",
    section: "Construire un message significatif",
    kind: "Savoir",
    parent: "Règles d’orthographe lexicale : construction des mots (morphologie).",
    modality: "écouter, parler, lire, écrire",
    text: "Connaitre les notions de synonyme, de champ lexical, de substitut lexical.",
  },
  {
    id: "FRALA-P3-5bc811ba",
    champ: "",
    section: "Construire un message significatif",
    kind: "Savoir",
    parent: "Relations sémantiques entre les mots.",
    modality: "écouter, parler, lire, écrire",
    text: "Connaitre des homophones fréquents.",
  },
  {
    id: "FRALA-P3-0c12f4ba",
    champ: "",
    section: "Construire un message significatif",
    kind: "Savoir",
    parent: "Facteurs de cohérence.",
    modality: "écouter, parler, lire, écrire",
    text: "Connaitre : - des connecteurs* de temps, d’espace et de lieu, d’énumération, de cause/explication, d’addition ; - les techniques de reprise de l’information* (reprise anaphorique*).",
  },
  {
    id: "FRALA-P3-4f7470a4",
    champ: "",
    section: "Construire un message significatif",
    kind: "Savoir",
    parent: "Facteurs de cohérence.",
    modality: "lire, écrire",
    text: "Connaitre les notions de classe, de fonction, d’accord, de genre, de nombre et de personne.",
  },
  {
    id: "FRALA-P3-fcf66c36",
    champ: "",
    section: "Construire un message significatif",
    kind: "Savoir",
    parent: "Termes du langage technique de la grammaire.",
    modality: "lire, écrire",
    text: "Connaitre les critères qui permettent de définir la classe : - du nom ; - du verbe ; - du déterminant ; - de l’adjectif.",
  },
  {
    id: "FRALA-P3-b381f6fe",
    champ: "",
    section: "Construire un message significatif",
    kind: "Savoir",
    parent: "Classe des mots.",
    modality: "lire, écrire",
    text: "Connaitre la règle générale de : - l’accord de l’adjectif en genre et en nombre ; - l’accord du déterminant en genre et en nombre ; - la formation du pluriel des noms et des adjectifs en « s » ; - la formation du féminin en « e » ; - l’accord du verbe avec le sujet.",
  },
  {
    id: "FRALA-P3-bfdd5830",
    champ: "",
    section: "Construire un message significatif",
    kind: "Savoir",
    parent: "Règles d’orthographe grammaticale.",
    modality: "lire, écrire",
    text: "Savoir que les noms ont un genre et varient en nombre.",
  },
  {
    id: "FRALA-P3-cc862f23",
    champ: "",
    section: "Construire un message significatif",
    kind: "Savoir",
    parent: "Règles d’orthographe grammaticale.",
    modality: "lire, écrire",
    text: "Connaitre la conjugaison (sans découvrir son système) à toutes les personnes au présent, au futur simple, au futur proche et au passé composé, des verbes fréquents et en -ER avec un radical stable.",
  },
  {
    id: "FRALA-P3-a51002f2",
    champ: "",
    section: "Construire un message significatif",
    kind: "Savoir",
    parent: "Conjugaison.",
    modality: "lire, écrire",
    text: "Connaitre deux des constituants principaux de la phrase simple* : - groupe sujet ; - groupe prédicat*.",
  },
  {
    id: "FRALA-P3-3327fb4f",
    champ: "",
    section: "Construire un message significatif",
    kind: "Savoir",
    parent: "Notion de phrase simple.",
    modality: "lire, écrire",
    text: "Connaitre les critères pour identifier la fonction : - sujet.",
  },
  {
    id: "FRALA-P3-dcf11248",
    champ: "",
    section: "Construire un message significatif",
    kind: "Savoir",
    parent: "Fonction des constituants* de la phrase.",
    modality: "parler, lire",
    text: "Connaitre les principes de la lecture à haute voix : liaisons, intonation, temps de pause.",
  },
  {
    id: "FRALA-P3-f3cbf3b9",
    champ: "",
    section: "Construire un message significatif",
    kind: "Savoir",
    parent: "Principes de la lecture à haute voix.",
    modality: "écouter",
    text: "Connaitre des démarches pour s’adapter au contexte d’écoute : - conduites sociales adéquates (attente, silence, gestes, sons) ; - écoute attentive.",
  },
  {
    id: "FRALA-P3-2c3504e3",
    champ: "",
    section: "Construire un message significatif",
    kind: "Savoir",
    parent: "Adaptation à la situation de communication.",
    modality: "écouter",
    text: "Respecter le tour et le temps de parole.",
  },
  {
    id: "FRALA-P3-1f056461",
    champ: "",
    section: "Construire un message significatif",
    kind: "Savoir",
    parent: "Adaptation à la situation de communication.",
    modality: "écouter",
    text: "Connaitre la façon d’intervenir à la suite d’une perte de compréhension (questions, demandes de clarification).",
  },
  {
    id: "FRALA-P3-7a10c11c",
    champ: "",
    section: "Construire un message significatif",
    kind: "Savoir",
    parent: "Adaptation à la situation de communication.",
    modality: "parler",
    text: "Connaitre des démarches pour tenir compte des interlocuteurs : - vigilance à l’effet produit par les idées émises ; - ajout d’éléments ou de précisions en fonction des réactions.",
  },
  {
    id: "FRALA-P3-24777f76",
    champ: "",
    section: "Construire un message significatif",
    kind: "Savoir",
    parent: "Adaptation à la situation de communication.",
    modality: "parler",
    text: "Connaitre des expressions pour demander la parole, pour introduire une prise de parole spontanée.",
  },
  {
    id: "FRALA-P3-2852c53d",
    champ: "",
    section: "Construire un message significatif",
    kind: "Savoir",
    parent: "Paramètres du corps et de la voix.",
    modality: "écouter, parler",
    text: "Repérer les paramètres de la voix : - débit ; - intonation ; - volume ; - pauses.",
  },
  {
    id: "FRALA-P3-a6ef955f",
    champ: "",
    section: "Construire un message significatif",
    kind: "Savoir",
    parent: "Paramètres du corps et de la voix.",
    modality: "écouter, parler",
    text: "Repérer les paramètres du corps : - posture et positions du corps ; - gestuelle ; - maintien du regard ; - expressions faciales (mimiques, hochements de tête) ; - déplacements.",
  },
  {
    id: "FRALA-P3-6dd1da83",
    champ: "",
    section: "Construire un message significatif",
    kind: "Savoir",
    parent: "Paramètres du corps et de la voix.",
    modality: "écouter, lire",
    text: "Nommer et décrire les stratégies/habiletés de compréhension : - se créer des images ((se) construire une représentation mentale du texte) ; - faire des hypothèses (anticipation et interprétation) et les vérifier ; - résumer (percevoir le sens global) ; - retrouver des informations (prélever des informations explicites) ; - lire entre les lignes (élaborer des inférences) ; - relier le texte et les illustrations (mettre en relation le texte et les illustrations).",
  },
  {
    id: "FRALA-P3-3f7f79b5",
    champ: "",
    section: "Construire un message significatif",
    kind: "Savoir",
    parent: "Stratégies/habiletés de compréhension.",
    modality: "écouter, lire",
    text: "Connaitre le rôle du contrôle de sa compréhension.",
  },
  {
    id: "FRALA-P3-85eda3f7",
    champ: "",
    section: "Construire un message significatif",
    kind: "Savoir",
    parent: "Stratégies/habiletés de compréhension.",
    modality: "écrire",
    text: "Maitriser les composantes de la production d’écrit : - planification ; - mise en texte ; - révision ; - correction.",
  },
  {
    id: "FRALA-P3-ed1cadd4",
    champ: "",
    section: "Construire un message significatif",
    kind: "Savoir",
    parent: "Composantes de la production d’un message oral ou écrit.",
    modality: "parler",
    text: "Maitriser les étapes d’une prise de parole préparée : - se présenter et introduire le sujet ; - présenter le sujet ; - conclure.",
  },
  {
    id: "FRALA-P3-e07e255c",
    champ: "",
    section: "Construire un message significatif",
    kind: "Savoir",
    parent: "Composantes de la production d’un message oral ou écrit.",
    modality: "parler",
    text: "Connaitre les freins et les facilitateurs de la communication (vocabulaire, formulations).",
  },
  {
    id: "FRALA-P3-91e78e0b",
    champ: "",
    section: "Construire un message significatif",
    kind: "Savoir",
    parent: "Composantes de la production d’un message oral ou écrit.",
    modality: "écouter, parler, lire, écrire",
    text: "Connaitre les caractéristiques générales des cinq structures textuelles : - narrative ; - argumentative ; - descriptive ; - dialoguée ; - explicative.",
  },
  {
    id: "FRALA-P3-38f6e499",
    champ: "",
    section: "Apprécier, agir/réagir, réviser",
    kind: "Savoir",
    parent: "Structures textuelles dominantes.",
    modality: "écouter, lire",
    text: "Connaitre des œuvres du patrimoine littéraire (contes, légendes…) rencontrées à l’école.",
  },
  {
    id: "FRALA-P3-6254dc9d",
    champ: "",
    section: "Apprécier, agir/réagir, réviser",
    kind: "Savoir",
    parent: "Culture littéraire.",
    modality: "écouter, lire",
    text: "Connaitre des œuvres contemporaines marquantes pour la jeunesse rencontrées à l’école.",
  },
  {
    id: "FRALA-P3-b97e7623",
    champ: "",
    section: "Orienter sa prise de parole, son écoute, sa lecture, son écrit",
    kind: "Savoir-faire",
    parent: "Tenir compte des paramètres de la situation de communication.",
    modality: "écouter, parler, lire, écrire",
    text: "Identifier l’énonciateur (qui), le destinataire (à qui), l’intention dominante (pour quoi), le message (quoi) et le contexte (où et quand) pour planifier sa prise de parole, son écoute, sa lecture et son écrit.",
  },
  {
    id: "FRALA-P3-3403e0dc",
    champ: "",
    section: "Orienter sa prise de parole, son écoute, sa lecture, son écrit",
    kind: "Savoir-faire",
    parent: "Tenir compte des paramètres de la situation de communication.",
    modality: "écouter, parler, lire, écrire",
    text: "S’adapter à la diversité des interlocuteurs : - connu/inconnu ; - familier/non familier ; - un/plusieurs ; - du même âge plus jeune/plus âgé.",
  },
  {
    id: "FRALA-P3-71995671",
    champ: "",
    section: "Orienter sa prise de parole, son écoute, sa lecture, son écrit",
    kind: "Savoir-faire",
    parent: "Tenir compte des paramètres de la situation de communication.",
    modality: "écouter",
    text: "Déterminer un but d’écoute selon l’intention précisée et le support utilisé.",
  },
  {
    id: "FRALA-P3-32ec47f1",
    champ: "",
    section: "Orienter sa prise de parole, son écoute, sa lecture, son écrit",
    kind: "Savoir-faire",
    parent: "Assigner un but à sa lecture ou son écoute.",
    modality: "lire",
    text: "Utiliser les termes du support de lecture comme indices pour anticiper le contenu d’un document.",
  },
  {
    id: "FRALA-P3-483b8e2d",
    champ: "",
    section: "Orienter sa prise de parole, son écoute, sa lecture, son écrit",
    kind: "Savoir-faire",
    parent: "Assigner un but à sa lecture ou son écoute.",
    modality: "parler, écrire",
    text: "Rassembler des idées avec ou sans support.",
  },
  {
    id: "FRALA-P3-27d928ee",
    champ: "",
    section: "Apprendre et utiliser le code",
    kind: "Savoir-faire",
    parent: "Planifier* son message oral ou écrit en tenant compte de l’intention et du destinataire.",
    modality: "lire",
    text: "Appliquer des stratégies de décodage pour accéder au sens de mots complexes ou inconnus.",
  },
  {
    id: "FRALA-P3-44e2bcb4",
    champ: "",
    section: "Apprendre et utiliser le code",
    kind: "Savoir-faire",
    parent: "Utiliser l’ensemble des correspondances graphophonétiques.",
    modality: "écrire",
    text: "Encoder des mots complexes ou inconnus : - en effectuant les conversions phonème-graphème ; - en utilisant sa mémoire ; - en utilisant ses connaissances orthographiques.",
  },
  {
    id: "FRALA-P3-26c33af5",
    champ: "",
    section: "Apprendre et utiliser le code",
    kind: "Savoir-faire",
    parent: "Utiliser l’ensemble des correspondances graphophonétiques.",
    modality: "écrire",
    text: "Utiliser dans une production personnelle : le point, le point d’interrogation, le point d’exclamation, les guillemets, le tiret, les points de suspension, la virgule (dans une énumération), les deux points, l’apostrophe et les parenthèses.",
  },
  {
    id: "FRALA-P3-14c7cf49",
    champ: "",
    section: "Apprendre et utiliser le code",
    kind: "Savoir-faire",
    parent: "Utiliser les caractéristiques graphiques de la phrase.",
    modality: "lire",
    text: "Lire avec exactitude, rapidité et expression un texte en respectant les groupes de sens.",
  },
  {
    id: "FRALA-P3-8735c03b",
    champ: "",
    section: "Construire du sens à l’aide de stratégies",
    kind: "Savoir-faire",
    parent: "Développer une lecture fluide (fluence*).",
    modality: "parler",
    text: "Mettre en mots sa pensée : - reformuler un enchainement de consignes ; - reformuler des informations lues ou entendues ; - verbaliser une suite d’actions réalisées par soi ou par autrui ; - exprimer une émotion.",
  },
  {
    id: "FRALA-P3-3dab56f3",
    champ: "",
    section: "Construire du sens à l’aide de stratégies",
    kind: "Savoir-faire",
    parent: "Structurer sa pensée dans des écrits ou échanges oraux réflexifs (croisement avec les autres disciplines).",
    modality: "parler",
    text: "Partager ses écrits réflexifs : - chercher à préciser sa pensée ; - expliciter ses idées, apporter des exemples.",
  },
  {
    id: "FRALA-P3-e122763f",
    champ: "",
    section: "Construire du sens à l’aide de stratégies",
    kind: "Savoir-faire",
    parent: "Structurer sa pensée dans des écrits ou échanges oraux réflexifs (croisement avec les autres disciplines).",
    modality: "écrire",
    text: "Consigner dans un journal personnel (écrit de travail) : - les apprentissages effectués dans les disciplines au terme d’une journée ; - une suite d’actions réalisées par soi ou par autrui.",
  },
  {
    id: "FRALA-P3-ae4ea7d2",
    champ: "",
    section: "Construire du sens à l’aide de stratégies",
    kind: "Savoir-faire",
    parent: "Structurer sa pensée dans des écrits ou échanges oraux réflexifs (croisement avec les autres disciplines).",
    modality: "écrire",
    text: "Exprimer un avis, un ressenti, une émotion.",
  },
  {
    id: "FRALA-P3-f1ecc45b",
    champ: "",
    section: "Construire du sens à l’aide de stratégies",
    kind: "Savoir-faire",
    parent: "Construire sa prise de parole spontanée ou préparée.",
    modality: "parler",
    text: "Évoquer ce que l’on connait du sujet.",
  },
  {
    id: "FRALA-P3-cfbe9a1c",
    champ: "",
    section: "Construire du sens à l’aide de stratégies",
    kind: "Savoir-faire",
    parent: "Construire sa prise de parole spontanée ou préparée.",
    modality: "parler",
    text: "Oser proposer des idées nouvelles.",
  },
  {
    id: "FRALA-P3-2e580596",
    champ: "",
    section: "Construire du sens à l’aide de stratégies",
    kind: "Savoir-faire",
    parent: "Construire sa prise de parole spontanée ou préparée.",
    modality: "parler",
    text: "Oser s’exprimer en dépit des maladresses syntaxiques, des répétitions et des hésitations dans les formulations.",
  },
  {
    id: "FRALA-P3-c974c932",
    champ: "",
    section: "Construire du sens à l’aide de stratégies",
    kind: "Savoir-faire",
    parent: "Construire sa prise de parole spontanée ou préparée.",
    modality: "parler",
    text: "Proposer diverses formulations.",
  },
  {
    id: "FRALA-P3-2d57a52f",
    champ: "",
    section: "Construire du sens à l’aide de stratégies",
    kind: "Savoir-faire",
    parent: "Construire sa prise de parole spontanée ou préparée.",
    modality: "parler",
    text: "Accepter d’utiliser provisoirement un vocabulaire approximatif ou le même mot pour exprimer diverses choses.",
  },
  {
    id: "FRALA-P3-6efbe35e",
    champ: "",
    section: "Construire du sens à l’aide de stratégies",
    kind: "Savoir-faire",
    parent: "Construire sa prise de parole spontanée ou préparée.",
    modality: "écouter, lire",
    text: "Détecter les pertes de compréhension et recourir à des stratégies pour y remédier.",
  },
  {
    id: "FRALA-P3-a2622ad7",
    champ: "",
    section: "Construire du sens à l’aide de stratégies",
    kind: "Savoir-faire",
    parent: "Contrôler sa compréhension.",
    modality: "écouter, lire",
    text: "Exprimer la représentation mentale du contenu du texte (entendu) par un moyen verbal ou non verbal (phrase, dessin, création…).",
  },
  {
    id: "FRALA-P3-564717ac",
    champ: "",
    section: "Construire du sens à l’aide de stratégies",
    kind: "Savoir-faire",
    parent: "(Se) Construire une représentation mentale du texte.",
    modality: "écouter, lire",
    text: "Formuler des hypothèses d’anticipation et d’interprétation et les vérifier.",
  },
  {
    id: "FRALA-P3-d1822d49",
    champ: "",
    section: "Construire du sens à l’aide de stratégies",
    kind: "Savoir-faire",
    parent: "Émettre des hypothèses d’anticipation et d’interprétation puis les vérifier.",
    modality: "écouter, lire",
    text: "Mettre en relation le sens du texte (entendu) avec son vécu.",
  },
  {
    id: "FRALA-P3-1c4e5ae5",
    champ: "",
    section: "Construire du sens à l’aide de stratégies",
    kind: "Savoir-faire",
    parent: "Émettre des hypothèses d’anticipation et d’interprétation puis les vérifier.",
    modality: "écouter, lire",
    text: "Exprimer avec ses mots une suite plausible au récit.",
  },
  {
    id: "FRALA-P3-25e6d9c0",
    champ: "",
    section: "Construire du sens à l’aide de stratégies",
    kind: "Savoir-faire",
    parent: "Émettre des hypothèses d’anticipation et d’interprétation puis les vérifier.",
    modality: "écouter, lire",
    text: "Confronter les significations construites personnellement au texte (entendu) et à celles élaborées par les pairs.",
  },
  {
    id: "FRALA-P3-17e5d9b6",
    champ: "",
    section: "Construire du sens à l’aide de stratégies",
    kind: "Savoir-faire",
    parent: "Émettre des hypothèses d’anticipation et d’interprétation puis les vérifier.",
    modality: "écouter",
    text: "Formuler au moins cinq informations explicites essentielles contenues dans un texte entendu.",
  },
  {
    id: "FRALA-P3-70379417",
    champ: "",
    section: "Construire du sens à l’aide de stratégies",
    kind: "Savoir-faire",
    parent: "Prélever des informations explicites.",
    modality: "lire",
    text: "Repérer des informations essentielles contenues dans un texte sur la base d’un questionnement.",
  },
  {
    id: "FRALA-P3-63d25a8b",
    champ: "",
    section: "Construire du sens à l’aide de stratégies",
    kind: "Savoir-faire",
    parent: "Prélever des informations explicites.",
    modality: "lire",
    text: "Formuler ou reformuler des informations essentielles contenues dans un texte.",
  },
  {
    id: "FRALA-P3-f944e340",
    champ: "",
    section: "Construire du sens à l’aide de stratégies",
    kind: "Savoir-faire",
    parent: "Prélever des informations explicites.",
    modality: "écouter",
    text: "Déduire des informations implicites à partir des liens exprimés entre des éléments du message, de son vécu, de ses connaissances.",
  },
  {
    id: "FRALA-P3-214e6ec8",
    champ: "",
    section: "Construire du sens à l’aide de stratégies",
    kind: "Savoir-faire",
    parent: "Élaborer des inférences.",
    modality: "lire",
    text: "Déduire des informations implicites en reliant : - des informations explicites proches ou éloignées ; - des informations du texte et son vécu ou ses connaissances du monde.",
  },
  {
    id: "FRALA-P3-746e2b41",
    champ: "",
    section: "Construire du sens à l’aide de stratégies",
    kind: "Savoir-faire",
    parent: "Élaborer des inférences.",
    modality: "écouter",
    text: "Exprimer avec ses mots le sens global du message entendu à l’aide d’un support proposé ou choisi.",
  },
  {
    id: "FRALA-P3-499cff88",
    champ: "",
    section: "Construire du sens à l’aide de stratégies",
    kind: "Savoir-faire",
    parent: "Percevoir le sens global.",
    modality: "écouter",
    text: "Reformuler des idées essentielles contenues dans le message entendu et dégagées collectivement.",
  },
  {
    id: "FRALA-P3-b60e9799",
    champ: "",
    section: "Construire du sens à l’aide de stratégies",
    kind: "Savoir-faire",
    parent: "Percevoir le sens global.",
    modality: "écouter",
    text: "Effectuer des tâches correspondant à un enchainement de consignes entendues.",
  },
  {
    id: "FRALA-P3-34547f53",
    champ: "",
    section: "Construire du sens à l’aide de stratégies",
    kind: "Savoir-faire",
    parent: "Percevoir le sens global.",
    modality: "lire",
    text: "Formuler l’idée principale d’un texte.",
  },
  {
    id: "FRALA-P3-421cbf83",
    champ: "",
    section: "Construire du sens à l’aide de stratégies",
    kind: "Savoir-faire",
    parent: "Percevoir le sens global.",
    modality: "lire",
    text: "Décrire la chronologie d’un texte simple et structuré.",
  },
  {
    id: "FRALA-P3-b0b15813",
    champ: "",
    section: "Construire du sens à l’aide de stratégies",
    kind: "Savoir-faire",
    parent: "Percevoir le sens global.",
    modality: "lire",
    text: "Expliquer les liens logiques existant entre les idées du texte.",
  },
  {
    id: "FRALA-P3-cb4f2d59",
    champ: "",
    section: "Construire du sens à l’aide de stratégies",
    kind: "Savoir-faire",
    parent: "Percevoir le sens global.",
    modality: "lire",
    text: "Reformuler ou exécuter un enchainement de deux consignes écrites.",
  },
  {
    id: "FRALA-P3-19831875",
    champ: "",
    section: "Construire du sens à l’aide de stratégies",
    kind: "Savoir-faire",
    parent: "Distinguer : - le réel (factuel) et l’imaginaire (fictionnel) ; - le vraisemblable et l’invraisemblable.",
    modality: "écouter, lire",
    text: "Dégager et reformuler : - les éléments réels ; - les éléments imaginaires ; - les éléments vraisemblables ; - les éléments invraisemblables.",
  },
  {
    id: "FRALA-P3-df1f2181",
    champ: "",
    section: "Construire du sens à l’aide de stratégies",
    kind: "Savoir-faire",
    parent: "Distinguer : - le réel (factuel) et l’imaginaire (fictionnel) ; - le vraisemblable et l’invraisemblable.",
    modality: "écouter, lire",
    text: "Relier les informations du texte aux indices fournis par l’illustration.",
  },
  {
    id: "FRALA-P3-c0c19960",
    champ: "",
    section: "Construire du sens à l’aide de stratégies",
    kind: "Savoir-faire",
    parent: "Mettre en relation le texte et les illustrations.",
    modality: "écouter, lire",
    text: "Construire le sens du message en restant fidèle au contenu lu.",
  },
  {
    id: "FRALA-P3-0a8b5e33",
    champ: "",
    section: "Construire du sens à l’aide de stratégies",
    kind: "Savoir-faire",
    parent: "Adopter une lecture respectueuse du contenu du message (droits du texte).",
    modality: "écouter, parler, lire",
    text: "Se mettre à la place d’un personnage (traits de caractères, valeurs, comportements).",
  },
  {
    id: "FRALA-P3-6e1d98cf",
    champ: "",
    section: "Construire du sens à l’aide de stratégies",
    kind: "Savoir-faire",
    parent: "Pratiquer une lecture participative.",
    modality: "écouter, parler, lire",
    text: "Exprimer une impression, une opinion.",
  },
  {
    id: "FRALA-P3-7b2032bb",
    champ: "",
    section: "Construire du sens à l’aide de stratégies",
    kind: "Savoir-faire",
    parent: "Pratiquer une lecture participative.",
    modality: "écouter, parler, lire",
    text: "Partager ses impressions.",
  },
  {
    id: "FRALA-P3-d5397714",
    champ: "",
    section: "Construire du sens à l’aide de stratégies",
    kind: "Savoir-faire",
    parent: "Pratiquer une lecture participative.",
    modality: "écouter, parler, lire",
    text: "Énoncer les ressemblances et des différences entre des œuvres et les comparer.",
  },
  {
    id: "FRALA-P3-e2662b34",
    champ: "",
    section: "Construire du sens à l’aide de stratégies",
    kind: "Savoir-faire",
    parent: "Pratiquer une lecture participative.",
    modality: "écouter, lire",
    text: "Dégager les valeurs défendues, le message véhiculé dans un récit.",
  },
  {
    id: "FRALA-P3-a4491c19",
    champ: "",
    section: "Construire du sens à l’aide de stratégies",
    kind: "Savoir-faire",
    parent: "Pratiquer une lecture distanciée*.",
    modality: "écouter, lire",
    text: "Identifier le narrateur.",
  },
  {
    id: "FRALA-P3-67c49d73",
    champ: "",
    section: "Construire du sens à l’aide de stratégies",
    kind: "Savoir-faire",
    parent: "Pratiquer une lecture distanciée*.",
    modality: "écouter, lire",
    text: "S’interroger sur l’intention de l’auteur.",
  },
  {
    id: "FRALA-P3-984f4bfa",
    champ: "",
    section: "Dégager et assurer la cohérence du message/texte",
    kind: "Savoir-faire",
    parent: "Pratiquer une lecture distanciée*.",
    modality: "écouter",
    text: "Dégager des caractéristiques du message entendu afin d’en identifier le genre (voir Tableau des genres proposés en page 32).",
  },
  {
    id: "FRALA-P3-3894ad1c",
    champ: "",
    section: "Dégager et assurer la cohérence du message/texte",
    kind: "Savoir-faire",
    parent: "Identifier le genre du message entendu ou du texte lu.",
    modality: "écouter",
    text: "Repérer les organisateurs textuels pour construire le sens.",
  },
  {
    id: "FRALA-P3-c2f4be91",
    champ: "",
    section: "Dégager et assurer la cohérence du message/texte",
    kind: "Savoir-faire",
    parent: "Identifier le genre du message entendu ou du texte lu.",
    modality: "écouter",
    text: "Identifier le contenu du message et la façon dont il est organisé : - choix des idées (pertinence, suffisance) ; - organisation des idées (enchainement des propos avec ce qui précède).",
  },
  {
    id: "FRALA-P3-d28fa549",
    champ: "",
    section: "Dégager et assurer la cohérence du message/texte",
    kind: "Savoir-faire",
    parent: "Identifier le genre du message entendu ou du texte lu.",
    modality: "lire",
    text: "Dégager les caractéristiques de la structure textuelle dominante afin d’en définir le genre (voir Tableau des genres proposés par structure textuelle).",
  },
  {
    id: "FRALA-P3-58650044",
    champ: "",
    section: "Dégager et assurer la cohérence du message/texte",
    kind: "Savoir-faire",
    parent: "Identifier le genre du message entendu ou du texte lu.",
    modality: "lire",
    text: "Utiliser les termes du support de lecture (paratexte) : titres, sous-titres, paragraphes.",
  },
  {
    id: "FRALA-P3-09905979",
    champ: "",
    section: "Dégager et assurer la cohérence du message/texte",
    kind: "Savoir-faire",
    parent: "Identifier le genre du message entendu ou du texte lu.",
    modality: "lire",
    text: "Utiliser les organisateurs textuels pour construire la cohérence.",
  },
  {
    id: "FRALA-P3-ba4fb876",
    champ: "",
    section: "Dégager et assurer la cohérence du message/texte",
    kind: "Savoir-faire",
    parent: "Organiser son message selon une structure textuelle dominante en fonction de la situation de communication.",
    modality: "parler",
    text: "Prendre la parole en s’aidant d’une structure textuelle proposée par l’enseignant pour organiser ses idées.",
  },
  {
    id: "FRALA-P3-54305d80",
    champ: "",
    section: "Dégager et assurer la cohérence du message/texte",
    kind: "Savoir-faire",
    parent: "Organiser son message selon une structure textuelle dominante en fonction de la situation de communication.",
    modality: "parler",
    text: "Utiliser des connecteurs* de temps, d’espace ou de lieu et d’énumération.",
  },
  {
    id: "FRALA-P3-f55d0df4",
    champ: "",
    section: "Dégager et assurer la cohérence du message/texte",
    kind: "Savoir-faire",
    parent: "Organiser son message selon une structure textuelle dominante en fonction de la situation de communication.",
    modality: "écrire",
    text: "Organiser les éléments donnés d’un texte selon les caractéristiques de la structure dominante proposée par l’enseignant.",
  },
  {
    id: "FRALA-P3-724ef98d",
    champ: "",
    section: "Dégager et assurer la cohérence du message/texte",
    kind: "Savoir-faire",
    parent: "Organiser son message selon une structure textuelle dominante en fonction de la situation de communication.",
    modality: "écrire",
    text: "Utiliser des mots ou expressions qui assurent l’enchainement des phrases.",
  },
  {
    id: "FRALA-P3-2c70ac07",
    champ: "",
    section: "Dégager et assurer la cohérence du message/texte",
    kind: "Savoir-faire",
    parent: "Organiser son message selon une structure textuelle dominante en fonction de la situation de communication.",
    modality: "écrire",
    text: "Utiliser des connecteurs de temps et d’énumération.",
  },
  {
    id: "FRALA-P3-48156db5",
    champ: "",
    section: "Dégager et assurer la cohérence du message/texte",
    kind: "Savoir-faire",
    parent: "Organiser son message selon une structure textuelle dominante en fonction de la situation de communication.",
    modality: "écrire",
    text: "Utiliser les temps appropriés en marquant le présent, le passé (passé composé), le futur (futur simple et futur proche) pour assurer la cohérence temporelle*.",
  },
  {
    id: "FRALA-P3-907d44ce",
    champ: "",
    section: "Dégager et assurer la cohérence du message/texte",
    kind: "Savoir-faire",
    parent: "Organiser son message selon une structure textuelle dominante en fonction de la situation de communication.",
    modality: "écouter, lire",
    text: "Identifier un référent et sa reprise anaphorique* : - substitut lexical ; - substitut grammatical (pronom personnel).",
  },
  {
    id: "FRALA-P3-579e244f",
    champ: "",
    section: "Dégager et assurer la cohérence du message/texte",
    kind: "Savoir-faire",
    parent: "Utiliser des reprises d’informations d’une phrase à l’autre pour construire du sens.",
    modality: "écouter, lire",
    text: "Repérer la (les) voix du (des) locuteur(s).",
  },
  {
    id: "FRALA-P3-e1ed2b6f",
    champ: "",
    section: "Dégager et assurer la cohérence du message/texte",
    kind: "Savoir-faire",
    parent: "Utiliser des reprises d’informations d’une phrase à l’autre pour construire du sens.",
    modality: "parler, écrire",
    text: "Assurer la reprise d’une information d’une phrase à l’autre en utilisant : - des substituts lexicaux ; - des pronoms personnels.",
  },
  {
    id: "FRALA-P3-0b62b2ab",
    champ: "",
    section: "Traiter/utiliser les unités lexicales",
    kind: "Savoir-faire",
    parent: "Utiliser des reprises d’informations d’une phrase à l’autre pour construire du sens.",
    modality: "lire, écrire",
    text: "Repérer des différences et des similitudes morphologiques et de relations sémantiques (synonymes) entre des mots écrits.",
  },
  {
    id: "FRALA-P3-bbffd111",
    champ: "",
    section: "Traiter/utiliser les unités lexicales",
    kind: "Savoir-faire",
    parent: "Observer le fonctionnement de la langue pour dégager des régularités.",
    modality: "lire, écrire",
    text: "Justifier une particularité orthographique en s’appuyant sur sa connaissance des mots.",
  },
  {
    id: "FRALA-P3-860a4b90",
    champ: "",
    section: "Traiter/utiliser les unités lexicales",
    kind: "Savoir-faire",
    parent: "Observer le fonctionnement de la langue pour dégager des régularités.",
    modality: "lire, écrire",
    text: "Faire ressortir les différents sens d’un mot en le plaçant dans plusieurs contextes.",
  },
  {
    id: "FRALA-P3-4d3aeb35",
    champ: "",
    section: "Traiter/utiliser les unités lexicales",
    kind: "Savoir-faire",
    parent: "Observer le fonctionnement de la langue pour dégager des régularités.",
    modality: "lire, écrire",
    text: "Relever différentes façons de nommer la même réalité.",
  },
  {
    id: "FRALA-P3-4544dea5",
    champ: "",
    section: "Traiter/utiliser les unités lexicales",
    kind: "Savoir-faire",
    parent: "Observer le fonctionnement de la langue pour dégager des régularités.",
    modality: "lire, écrire",
    text: "Observer les règles de positions : - c et ç ; - g et ge ; - g et gu ; - s entre deux voyelles ; - m devant p, b et m.",
  },
  {
    id: "FRALA-P3-773bf934",
    champ: "",
    section: "Traiter/utiliser les unités lexicales",
    kind: "Savoir-faire",
    parent: "Observer le fonctionnement de la langue pour dégager des régularités.",
    modality: "lire",
    text: "Émettre des hypothèses sur le sens d’un mot inconnu à partir de sa forme et le vérifier.",
  },
  {
    id: "FRALA-P3-d01f47fb",
    champ: "",
    section: "Traiter/utiliser les unités lexicales",
    kind: "Savoir-faire",
    parent: "Utiliser les règles d’orthographe lexicale pour produire du sens.",
    modality: "écrire",
    text: "Émettre des hypothèses sur l’orthographe d’un mot inconnu et laisser une trace du doute pour la vérifier.",
  },
  {
    id: "FRALA-P3-cd0b4852",
    champ: "",
    section: "Traiter/utiliser les unités lexicales",
    kind: "Savoir-faire",
    parent: "Utiliser les règles d’orthographe lexicale pour produire du sens.",
    modality: "écrire",
    text: "Verbaliser/schématiser les relations que les mots entretiennent entre eux (cartes thématiques ou constellation de mots).",
  },
  {
    id: "FRALA-P3-fea5f665",
    champ: "",
    section: "Traiter/utiliser les unités lexicales",
    kind: "Savoir-faire",
    parent: "Repérer les homonymes.",
    modality: "lire, écrire",
    text: "Prendre appui sur le contexte pour distinguer des homophones.",
  },
  {
    id: "FRALA-P3-9c76fc0d",
    champ: "",
    section: "Traiter/utiliser les unités lexicales",
    kind: "Savoir-faire",
    parent: "Repérer les homonymes.",
    modality: "lire, écrire",
    text: "Choisir la graphie correcte d’un homophone en s’appuyant sur le contexte.",
  },
  {
    id: "FRALA-P3-e38b3b46",
    champ: "",
    section: "Traiter/utiliser les unités lexicales",
    kind: "Savoir-faire",
    parent: "Repérer les homonymes.",
    modality: "parler, écrire",
    text: "Utiliser, en tenant compte de la situation de communication, les mots du lexique courant et du lexique spécifique à une thématique ou un champ disciplinaire.",
  },
  {
    id: "FRALA-P3-e09d02ba",
    champ: "",
    section: "Traiter/utiliser les unités lexicales",
    kind: "Savoir-faire",
    parent: "Utiliser le lexique.",
    modality: "parler, écrire",
    text: "Réinvestir de nouveaux mots et de nouvelles expressions ayant émergé en classe ou issus d’œuvres de littérature.",
  },
  {
    id: "FRALA-P3-b276e92f",
    champ: "",
    section: "Traiter/utiliser les unités lexicales",
    kind: "Savoir-faire",
    parent: "Utiliser le lexique.",
    modality: "parler, écrire",
    text: "Remplacer un mot par un mot du même champ lexical*.",
  },
  {
    id: "FRALA-P3-2360a296",
    champ: "",
    section: "Traiter/utiliser les unités lexicales",
    kind: "Savoir-faire",
    parent: "Utiliser le lexique.",
    modality: "parler, écrire",
    text: "Remplacer un mot par un autre de même sens.",
  },
  {
    id: "FRALA-P3-6d1cb7f4",
    champ: "",
    section: "Traiter/utiliser les unités grammaticales",
    kind: "Savoir-faire",
    parent: "Utiliser le lexique.",
    modality: "écrire",
    text: "Respecter la structure des phrases simples dans une production écrite en utilisant la ponctuation de manière adéquate.",
  },
  {
    id: "FRALA-P3-0126333f",
    champ: "",
    section: "Traiter/utiliser les unités grammaticales",
    kind: "Savoir-faire",
    parent: "Utiliser l’unité phrase.",
    modality: "lire, écrire",
    text: "Reconnaitre dans une phrase, un texte, une production personnelle : - nom ; - verbe ; - déterminant ; - adjectif.",
  },
  {
    id: "FRALA-P3-b3de2f72",
    champ: "",
    section: "Traiter/utiliser les unités grammaticales",
    kind: "Savoir-faire",
    parent: "Utiliser la notion de classe des mots.",
    modality: "parler, lire",
    text: "Repérer des différences et des similitudes de formes dans des phrases écrites (en prenant distance par rapport au contenu).",
  },
  {
    id: "FRALA-P3-ae78323b",
    champ: "",
    section: "Traiter/utiliser les unités grammaticales",
    kind: "Savoir-faire",
    parent: "Observer le fonctionnement de la langue.",
    modality: "parler, lire",
    text: "Observer les règles particulières de la formation du féminin.",
  },
  {
    id: "FRALA-P3-29d67200",
    champ: "",
    section: "Traiter/utiliser les unités grammaticales",
    kind: "Savoir-faire",
    parent: "Observer le fonctionnement de la langue.",
    modality: "parler, lire",
    text: "Observer les règles particulières de la formation du pluriel des noms et des adjectifs.",
  },
  {
    id: "FRALA-P3-6f7f16de",
    champ: "",
    section: "Traiter/utiliser les unités grammaticales",
    kind: "Savoir-faire",
    parent: "Observer le fonctionnement de la langue.",
    modality: "parler, lire",
    text: "Récolter des éléments en fonction de leurs similitudes pour constituer des groupes.",
  },
  {
    id: "FRALA-P3-6a624654",
    champ: "",
    section: "Traiter/utiliser les unités grammaticales",
    kind: "Savoir-faire",
    parent: "Dégager des régularités.",
    modality: "parler, lire",
    text: "Étiqueter les groupes (ex. : classe, fonction) et les sous-groupes (ex. : nom, déterminant...).",
  },
  {
    id: "FRALA-P3-2097b5c6",
    champ: "",
    section: "Traiter/utiliser les unités grammaticales",
    kind: "Savoir-faire",
    parent: "Dégager des régularités.",
    modality: "écouter, lire",
    text: "Repérer et verbaliser les nuances apportées par les marques (audibles) nominales : - du nombre (singulier/pluriel) ; - du genre (masculin/féminin).",
  },
  {
    id: "FRALA-P3-f3ca4563",
    champ: "",
    section: "Traiter/utiliser les unités grammaticales",
    kind: "Savoir-faire",
    parent: "Prendre appui sur les indices grammaticaux pour construire le sens d’un message entendu ou lu.",
    modality: "écouter, lire",
    text: "Repérer et verbaliser les nuances apportées par les marques verbales : - de personne et de nombre ; - de temps (présent, passé, futur).",
  },
  {
    id: "FRALA-P3-27812749",
    champ: "",
    section: "Traiter/utiliser les unités grammaticales",
    kind: "Savoir-faire",
    parent: "Prendre appui sur les indices grammaticaux pour construire le sens d’un message entendu ou lu.",
    modality: "écouter, lire",
    text: "Repérer les pronoms personnels.",
  },
  {
    id: "FRALA-P3-9e1346e2",
    champ: "",
    section: "Traiter/utiliser les unités grammaticales",
    kind: "Savoir-faire",
    parent: "Prendre appui sur les indices grammaticaux pour construire le sens d’un message entendu ou lu.",
    modality: "écouter, lire",
    text: "Repérer et verbaliser les nuances apportées par les marques de la négation.",
  },
  {
    id: "FRALA-P3-463f7214",
    champ: "",
    section: "Traiter/utiliser les unités grammaticales",
    kind: "Savoir-faire",
    parent: "Prendre appui sur les indices grammaticaux pour construire le sens d’un message entendu ou lu.",
    modality: "écouter, lire",
    text: "Repérer et verbaliser les nuances apportées par les marques de l’assertion de l’interrogation, de l’injonction.",
  },
  {
    id: "FRALA-P3-060428de",
    champ: "",
    section: "Traiter/utiliser les unités grammaticales",
    kind: "Savoir-faire",
    parent: "Utiliser les règles d’orthographe grammaticale.",
    modality: "parler, écrire",
    text: "Accorder le verbe avec le sujet.",
  },
  {
    id: "FRALA-P3-e9416d4a",
    champ: "",
    section: "Traiter/utiliser les unités grammaticales",
    kind: "Savoir-faire",
    parent: "Utiliser les règles d’orthographe grammaticale.",
    modality: "parler, écrire",
    text: "Accorder les déterminants en genre et en nombre.",
  },
  {
    id: "FRALA-P3-e7b0ef93",
    champ: "",
    section: "Traiter/utiliser les unités grammaticales",
    kind: "Savoir-faire",
    parent: "Utiliser les règles d’orthographe grammaticale.",
    modality: "parler, écrire",
    text: "Accorder les adjectifs en genre et en nombre.",
  },
  {
    id: "FRALA-P3-5d1ead05",
    champ: "",
    section: "Traiter/utiliser les unités grammaticales",
    kind: "Savoir-faire",
    parent: "Utiliser les règles d’orthographe grammaticale.",
    modality: "parler, écrire",
    text: "Conjuguer des verbes fréquents et des verbes en -ER avec un radical stable au présent, au futur simple, au futur proche et au passé composé à toutes les personnes.",
  },
  {
    id: "FRALA-P3-9aaf709e",
    champ: "",
    section: "Traiter/utiliser les unités grammaticales",
    kind: "Savoir-faire",
    parent: "Conjuguer.",
    modality: "parler, écrire",
    text: "Utiliser les formes verbales assurant la construction grammaticale correcte des phrases et la cohérence temporelle*.",
  },
  {
    id: "FRALA-P3-571ae4c3",
    champ: "",
    section: "Assurer la présentation du message",
    kind: "Savoir-faire",
    parent: "Respecter le système temporel choisi.",
    modality: "parler",
    text: "Se présenter et introduire le sujet.",
  },
  {
    id: "FRALA-P3-d15eb0eb",
    champ: "",
    section: "Assurer la présentation du message",
    kind: "Savoir-faire",
    parent: "Structurer sa prise de parole préparée.",
    modality: "parler",
    text: "Présenter le sujet.",
  },
  {
    id: "FRALA-P3-0087a1e1",
    champ: "",
    section: "Assurer la présentation du message",
    kind: "Savoir-faire",
    parent: "Structurer sa prise de parole préparée.",
    modality: "parler",
    text: "Conclure.",
  },
  {
    id: "FRALA-P3-92f0b7cc",
    champ: "",
    section: "Assurer la présentation du message",
    kind: "Savoir-faire",
    parent: "Structurer sa prise de parole préparée.",
    modality: "parler",
    text: "Adapter le volume, le débit de sa voix à son public, rendre fluide sa lecture à haute voix.",
  },
  {
    id: "FRALA-P3-e4371b6c",
    champ: "",
    section: "Assurer la présentation du message",
    kind: "Savoir-faire",
    parent: "Rendre son message audible et intelligible.",
    modality: "parler",
    text: "Articuler, respecter les pauses et la syntaxe.",
  },
  {
    id: "FRALA-P3-84e0d005",
    champ: "",
    section: "Assurer la présentation du message",
    kind: "Savoir-faire",
    parent: "Rendre son message audible et intelligible.",
    modality: "parler",
    text: "S’exprimer avec l’intonation adaptée en respectant les liaisons courantes.",
  },
  {
    id: "FRALA-P3-46a22b03",
    champ: "",
    section: "Assurer la présentation du message",
    kind: "Savoir-faire",
    parent: "Rendre son message audible et intelligible.",
    modality: "parler",
    text: "Utiliser à bon escient les gestes adaptés à la prise de parole. Utiliser un support de présentation pour appuyer son propos.",
  },
  {
    id: "FRALA-P3-b6fd69fc",
    champ: "",
    section: "Assurer la présentation du message",
    kind: "Savoir-faire",
    parent: "Rendre son message audible et intelligible.",
    modality: "parler",
    text: "Demander la parole.",
  },
  {
    id: "FRALA-P3-f1916816",
    champ: "",
    section: "Assurer la présentation du message",
    kind: "Savoir-faire",
    parent: "Respecter les règles de prise de parole.",
    modality: "parler",
    text: "Intervenir au moment approprié (à tour de rôle, en alternance, sur demande).",
  },
  {
    id: "FRALA-P3-69105869",
    champ: "",
    section: "Assurer la présentation du message",
    kind: "Savoir-faire",
    parent: "Respecter les règles de prise de parole.",
    modality: "parler",
    text: "Se tenir droit.",
  },
  {
    id: "FRALA-P3-8cac0a08",
    champ: "",
    section: "Assurer la présentation du message",
    kind: "Savoir-faire",
    parent: "Respecter les règles de prise de parole.",
    modality: "parler",
    text: "Regarder son destinataire, l’auditoire.",
  },
  {
    id: "FRALA-P3-f03f5686",
    champ: "",
    section: "Assurer la présentation du message",
    kind: "Savoir-faire",
    parent: "Respecter les règles de prise de parole.",
    modality: "parler",
    text: "Utiliser à bon escient des expressions types pour respecter des règles de courtoisie.",
  },
  {
    id: "FRALA-P3-4aaf793d",
    champ: "",
    section: "Assurer la présentation du message",
    kind: "Savoir-faire",
    parent: "Respecter les règles de prise de parole.",
    modality: "parler",
    text: "Tenir compte des réactions de son auditoire/ses interlocuteurs et y adapter son message : - vigilance à l’effet produit par les idées émises ; - ajout d’éléments ou de précisions en fonction des réactions.",
  },
  {
    id: "FRALA-P3-1aac9f9b",
    champ: "",
    section: "Assurer la présentation du message",
    kind: "Savoir-faire",
    parent: "Appliquer des règles d’écoute selon la situation de communication.",
    modality: "écouter",
    text: "Témoigner de son écoute en : - regardant l’énonciateur ; - adoptant une posture d’écoute ; - signalant celle-ci par des gestes (mimiques, sourire, signe de tête) ; - formulant un commentaire sur la voix (volume, débit, intonation).",
  },
  {
    id: "FRALA-P3-4afb40a1",
    champ: "",
    section: "Assurer la présentation du message",
    kind: "Savoir-faire",
    parent: "Appliquer des règles d’écoute selon la situation de communication.",
    modality: "écouter",
    text: "Établir un lien entre le contenu du message et un support illustré.",
  },
  {
    id: "FRALA-P3-c017e9ff",
    champ: "",
    section: "Assurer la présentation du message",
    kind: "Savoir-faire",
    parent: "Appliquer des règles d’écoute selon la situation de communication.",
    modality: "écouter",
    text: "S’adapter au contexte d’écoute par : - des conduites sociales adéquates (attente, silence, gestes, sons) ; - une écoute attentive.",
  },
  {
    id: "FRALA-P3-9bf6ee66",
    champ: "",
    section: "Assurer la présentation du message",
    kind: "Savoir-faire",
    parent: "Appliquer des règles d’écoute selon la situation de communication.",
    modality: "écrire",
    text: "Automatiser le tracé correct des lettres pour assurer la lisibilité et la présentation de son texte.",
  },
  {
    id: "FRALA-P3-66922892",
    champ: "",
    section: "Apprécier, agir/réagir, réviser",
    kind: "Savoir-faire",
    parent: "Maitriser le geste graphique.",
    modality: "écouter, parler",
    text: "Questionner ses interlocuteurs : - suite à une difficulté de compréhension ; - pour en savoir plus sur le sujet.",
  },
  {
    id: "FRALA-P3-b59a2de8",
    champ: "",
    section: "Apprécier, agir/réagir, réviser",
    kind: "Savoir-faire",
    parent: "Interagir avec autrui.",
    modality: "écouter, parler",
    text: "Répondre à des questions posées à la suite d’une prise de parole préparée.",
  },
  {
    id: "FRALA-P3-99355bbf",
    champ: "",
    section: "Apprécier, agir/réagir, réviser",
    kind: "Savoir-faire",
    parent: "Interagir avec autrui.",
    modality: "écouter, parler",
    text: "Formuler un avis à propos d’une présentation.",
  },
  {
    id: "FRALA-P3-37134727",
    champ: "",
    section: "Apprécier, agir/réagir, réviser",
    kind: "Savoir-faire",
    parent: "Interagir avec autrui.",
    modality: "écouter, parler",
    text: "Revenir au sujet lorsqu’on s’en éloigne.",
  },
  {
    id: "FRALA-P3-c7fb95e2",
    champ: "",
    section: "Apprécier, agir/réagir, réviser",
    kind: "Savoir-faire",
    parent: "Interagir avec autrui.",
    modality: "écouter, parler, lire",
    text: "Intégrer de nouvelles informations à son réseau de connaissances et les verbaliser.",
  },
  {
    id: "FRALA-P3-a577e682",
    champ: "",
    section: "Apprécier, agir/réagir, réviser",
    kind: "Savoir-faire",
    parent: "Élargir sa connaissance du monde.",
    modality: "écouter, parler, lire",
    text: "Prendre appui sur ses connaissances culturelles (littéraire, scientifique, artistique…) pour identifier ses préférences (auteur, genre…).",
  },
  {
    id: "FRALA-P3-18802b38",
    champ: "",
    section: "Apprécier, agir/réagir, réviser",
    kind: "Savoir-faire",
    parent: "Se construire une identité de lecteur.",
    modality: "parler, lire",
    text: "Vérifier le maintien du but de lecture assigné.",
  },
  {
    id: "FRALA-P3-0fd564ba",
    champ: "",
    section: "Apprécier, agir/réagir, réviser",
    kind: "Savoir-faire",
    parent: "Réfléchir à sa pratique de lecteur.",
    modality: "parler, lire",
    text: "Expliquer les stratégies de compréhension et d’interprétation mises en œuvre.",
  },
  {
    id: "FRALA-P3-bc7f698a",
    champ: "",
    section: "Apprécier, agir/réagir, réviser",
    kind: "Savoir-faire",
    parent: "Réfléchir à sa pratique de lecteur.",
    modality: "parler, lire",
    text: "Autoévaluer sa maitrise des stratégies.",
  },
  {
    id: "FRALA-P3-bfff4d44",
    champ: "",
    section: "Vérifier et ajuster sa production",
    kind: "Savoir-faire",
    parent: "Réfléchir à sa pratique de lecteur.",
    modality: "parler",
    text: "Vérifier, selon la réaction du ou des destinataires, si l’intention de communication a été atteinte.",
  },
  {
    id: "FRALA-P3-cc76d3f1",
    champ: "",
    section: "Vérifier et ajuster sa production",
    kind: "Savoir-faire",
    parent: "Évaluer une prise de parole préparée.",
    modality: "parler",
    text: "Ajuster son propos quand on perd l’attention de son interlocuteur.",
  },
  {
    id: "FRALA-P3-19147780",
    champ: "",
    section: "Vérifier et ajuster sa production",
    kind: "Savoir-faire",
    parent: "Évaluer une prise de parole préparée.",
    modality: "parler",
    text: "Relever des éléments moins réussis de sa communication en cernant ce qui n’a pas été bien saisi.",
  },
  {
    id: "FRALA-P3-d71a650c",
    champ: "",
    section: "Vérifier et ajuster sa production",
    kind: "Savoir-faire",
    parent: "Évaluer une prise de parole préparée.",
    modality: "écouter",
    text: "Évaluer la qualité de son écoute.",
  },
  {
    id: "FRALA-P3-6766ac5b",
    champ: "",
    section: "Écouter dans une situation d’échanges",
    kind: "Compétence",
    parent: "Écouter dans une situation d’échanges.",
    modality: "écouter",
    text: "Lors d’un échange en groupe : - témoigner de son écoute ; - adopter une posture d’écoute attentive ; - respecter les tours et les temps de parole.",
  },
  {
    id: "FRALA-P3-8afc3666",
    champ: "",
    section: "Manifester sa compréhension",
    kind: "Compétence",
    parent: "Manifester sa compréhension d’un document dont l’intention est :",
    modality: "écouter",
    text: "En répondant à des questions ou en produisant un dessin, quelques phrases ou une action qui donne à voir certains des éléments suivants : - les liens établis entre l’implicite et l’explicite ; - les connaissances personnelles mobilisées/modifiées ; - l’intention de l’auteur ; - les caractéristiques de sa structure textuelle permettant d’identifier son genre ; - les relations entre les éléments (texte-illustrations) ; - les mots appartenant à un même champ lexical.",
  },
  {
    id: "FRALA-P3-3efe5d53",
    champ: "",
    section: "Manifester sa compréhension",
    kind: "Compétence",
    parent: "- d’informer ;",
    modality: "écouter",
    text: "- les liens établis entre l’implicite et l’explicite ; - une émotion ressentie ; - l’intention de l’auteur ; - les caractéristiques de sa structure textuelle permettant d’identifier son genre ; - les relations entre les éléments (liens logiques).",
  },
  {
    id: "FRALA-P3-bf28f994",
    champ: "",
    section: "Manifester sa compréhension",
    kind: "Compétence",
    parent: "- d’enjoindre ;",
    modality: "écouter",
    text: "- les liens établis entre l’implicite et l’explicite ; - une émotion ressentie ; - l’intention de l’auteur ; - les caractéristiques de sa structure textuelle permettant d’identifier son genre ; - les relations entre les éléments (chronologie, liens logiques) ; - les mots appartenant à un même champ lexical*. En exécutant un enchainement de plusieurs consignes.",
  },
  {
    id: "FRALA-P3-80c851c7",
    champ: "",
    section: "Manifester sa compréhension",
    kind: "Compétence",
    parent: "- de donner du plaisir/des émotions.",
    modality: "écouter",
    text: "- les liens établis entre l’implicite et l’explicite ; - une émotion ressentie, l’empathie éprouvée pour un personnage ; - l’intention de l’auteur ; - les caractéristiques de sa structure textuelle permettant d’identifier son genre ; - les relations entre les éléments (chronologie, texte-illustrations) ; - les mots appartenant à un même champ lexical ; - les éléments réels et imaginaires ; - les éléments vraisemblables et invraisemblables. En imaginant une suite cohérente à un récit en tenant compte des informations livrées dans la ou les premières parties de celui-ci.",
  },
  {
    id: "FRALA-P3-738d95ab",
    champ: "",
    section: "Expliciter sa compréhension",
    kind: "Compétence",
    parent: "Vérifier et justifier sa compréhension d’un document.",
    modality: "écouter",
    text: "En répondant à des questions posées oralement, expliciter les stratégies de compréhension mobilisées : - prélever des informations explicites ; - élaborer une inférence ; - faire des hypothèses ; - relier le texte et les illustrations ; - percevoir le sens global ; - (se) construire une représentation mentale du texte.",
  },
  {
    id: "FRALA-P3-6f40d8ea",
    champ: "",
    section: "Expliciter sa compréhension",
    kind: "Compétence",
    parent: "Vérifier et justifier sa compréhension d’un document.",
    modality: "écouter",
    text: "Détecter une perte de compréhension et réajuster celle-ci après une confrontation avec les pairs.",
  },
  {
    id: "FRALA-P3-09a3f223",
    champ: "",
    section: "COMPÉTENCES DANS LES VISÉES DE PRODUCTION",
    kind: "Compétence",
    parent: "Vérifier et justifier sa compréhension d’un document.",
    modality: "écouter",
    text: "Produire un écrit",
  },
  {
    id: "FRALA-P3-b225daa8",
    champ: "",
    section: "COMPÉTENCES DANS LES VISÉES DE PRODUCTION",
    kind: "Compétence",
    parent: "Vérifier et justifier sa compréhension d’un document.",
    modality: "écouter",
    text: "Rédiger un écrit lisible qui combine plusieurs des éléments suivants en mobilisant des ressources (référentiels) : - en restant dans le sujet ; - en tenant compte de l’intention et du destinataire ; - en l’organisant selon une structure textuelle simple donnée ; - en utilisant la majuscule et le point ; - en orthographiant correctement les mots connus ; - en mobilisant les ressources de la classe (référentiels) ; - les organisateurs textuels adéquats ; - en utilisant les substituts lexicaux.",
  },
  {
    id: "FRALA-P3-da6959c1",
    champ: "",
    section: "Expliciter les composantes de sa production",
    kind: "Compétence",
    parent: "Verbaliser les composantes de la production d’écrits.",
    modality: "écouter",
    text: "En répondant à des questions posées oralement, expliciter les composantes de la production d’écrits mises en œuvre : - planification ; - mise en texte ; - révision ; - correction.",
  },
  {
    id: "FRALA-P3-3b6c484d",
    champ: "",
    section: "Restituer un contenu/message donné",
    kind: "Compétence",
    parent: "Prendre la parole pour :",
    modality: "écouter",
    text: "Prendre la parole pour restituer un contenu/message donné avec expression : - en tenant compte de l’intention et du destinataire ; - en adaptant le volume, le débit, la posture, les expressions et le regard ; - en utilisant les étapes d’une prise de parole préparée : se présenter, introduire le sujet, le présenter, conclure.",
  },
  {
    id: "FRALA-P3-1edc0f64",
    champ: "",
    section: "Restituer un contenu/message donné",
    kind: "Compétence",
    parent: "- donner du plaisir/susciter des émotions ; - persuader/convaincre ; - enjoindre.",
    modality: "écouter",
    text: "- en tenant compte de l’intention et du destinataire ; - en adaptant le volume, le débit, la posture, les expressions et le regard ; - en utilisant des règles de courtoisie.",
  },
  {
    id: "FRALA-P3-7535e225",
    champ: "",
    section: "Produire/élaborer un message",
    kind: "Compétence",
    parent: "Prendre la parole pour :",
    modality: "écouter",
    text: "Prendre la parole pour produire/élaborer un message qui combine plusieurs des éléments suivants en s’appuyant ou non sur un support de présentation : - en tenant compte de l’intention et du destinataire ; - en l’organisant selon une structure textuelle simple donnée ; - en utilisant les organisateurs textuels adéquats ; - en utilisant les substituts lexicaux ; - en utilisant le lexique (courant ou spécifique à la thématique y compris scolaire) adéquat ; - en utilisant les formes verbales qui assurent la cohérence temporelle* ; - en assurant la reprise anaphorique* (substituts lexicaux et pronoms personnels) ; - en mobilisant les ressources de la classe (référentiels).",
  },
  {
    id: "FRALA-P3-6aa4f3cd",
    champ: "",
    section: "Produire/élaborer un message",
    kind: "Compétence",
    parent: "- informer ; - donner du plaisir/susciter des émotions ; - persuader/convaincre ; - enjoindre.",
    modality: "écouter",
    text: "Interagir avec autrui",
  },
  {
    id: "FRALA-P3-1470d514",
    champ: "",
    section: "Produire/élaborer un message",
    kind: "Compétence",
    parent: "Prendre la parole en interagissant avec autrui.",
    modality: "écouter",
    text: "Prendre la parole dans un groupe : - en osant s’exprimer ; - en intervenant au moment approprié ; - en questionnant ses interlocuteurs ; - en répondant à des questions ; - en respectant les règles de courtoisie.",
  },
  {
    id: "FRALA-P3-5cb2c39f",
    champ: "",
    section: "Produire/élaborer un message",
    kind: "Compétence",
    parent: "Prendre la parole en interagissant avec autrui.",
    modality: "écouter",
    text: "Partager ses écrits réflexifs : - en cherchant à préciser sa pensée ; - en explicitant ses idées, apporter des exemples.",
  },
];
